let a = 0;

// Func = limiting Scope for this file
(function(){

	function resizeWindow(){

	}
	function scrollDown(){
		let top = $(document).scrollTop();
		if (top > 0) {

		} else {

		}

		//home number animations
		if( $('.counter-value').length > 0 ){
			var oTop = $('#numbers').offset().top - window.innerHeight;
			if (a == 0 && $(window).scrollTop() > oTop) {
				$('.counter-value').each(function() {
					var $this = $(this),
						countTo = $this.attr('data-count');
					$({
						countNum: $this.text()
					}).animate({
							countNum: countTo
						},

						{

							duration: 2600,
							easing: 'swing',
							step: function() {
								$this.text(Math.floor(this.countNum));
							},
							complete: function() {
								$this.text(this.countNum);
								//alert('finished');
							}

						});
				});
				a = 1;
			}
		}
	}

	$(document).ready(function () {

		//Call function with browser is resized.
		$(window).resize(function (event) {
			resizeWindow();
		});
		resizeWindow();

		//Acts when scroll down page.
		$(window).scroll(function (event) {
			scrollDown();
		});

		// Main Nav Dropdown
		$("#primary-nav li").hover(function(){
			$(this).addClass("hover");
			$('ul.submenu',this).fadeIn(200);
		}, function(){
			$(this).removeClass("hover");
			$('ul.submenu',this).fadeOut(200);
		});

		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		let DATE_STYLE = [true];
		function calendarRange(date){			
			let d1=$.datepicker.parseDate(DATE_FORMAT,$('#CheckIn').val());		
			let d2=$.datepicker.parseDate(DATE_FORMAT,$('#CheckOut').val());
			if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
				DATE_STYLE[1] = 'highlight-top';
			}else if(date > d1 && date < d2){
				DATE_STYLE[1] = 'highlight';
			}else{
				DATE_STYLE[1] = '';
			}
			return DATE_STYLE;
		}

		//Check in and check out datepicker for booking engine
		const DATE_FORMAT = ($("#CheckIn").data("format") !== undefined && $("#CheckIn").data("format")) ? $("#CheckIn").data("format") : "yy-mm-dd";		
        $( "#CheckIn" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			changeMonth: true,
            dateFormat: DATE_FORMAT,
            numberOfMonths: 1,
			minDate: 0,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 3);
				$( "#CheckOut" ).datepicker( "setDate", newDate );
				$( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );
			}
		});
		$( "#CheckOut" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
            dateFormat: DATE_FORMAT,
            changeMonth: true,
			numberOfMonths: 1,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				//$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
			}
		});

		// Map: Return to previous page button. Change body id to match map template's name.
		//$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');

		// Burger menu on tablet
		const BURGER_MENU = document.querySelector('.js-header--main-menu'),
			BOX_HEADER = document.querySelector('.js-header'),
			TEXT_BURGER_MENU = document.querySelector('.js-text-burger-menu');
		BURGER_MENU.addEventListener('click', () => {
			BOX_HEADER.classList.toggle('header__open-menu');
			BOX_HEADER.classList.contains('header__open-menu') ? TEXT_BURGER_MENU.textContent = 'Close' : TEXT_BURGER_MENU.textContent = 'Menu';
		});

		//Booking widget behavior for tablet only
		let bookingTrigger = document.querySelector('.js-booking-trigger'),
			bookingWidget = document.querySelector('.js-booking-widget');
		bookingTrigger.addEventListener('click',()=>{
			bookingWidget.classList.toggle('booking-widget__opened');
		});

		let scrollTrigger = $('.scroll-trigger'),
			scrollTarget = $('#formRFP');
		if(scrollTrigger !== null && scrollTarget !== null){
			scrollTrigger.click(function() {
				$([document.documentElement, document.body]).animate({
					scrollTop: (scrollTarget.offset().top) - 255
				}, 0);
			});
		};

		//ADA Map link on Map page
		$('body#map').append('<div role="region" aria-label="Go to ADA Map"><a href="/ada-map" class="btn btn-ada"> Go to ADA Map</a></div>');

	});

	// $(window).on('load', function() {});

}());